module.exports = __webpack_public_path__ + "static/media/ins-mesage.35dc3e2f.svg";